// ============================================================================
// PERSISTENT SEGMENT TREE - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'persistent-segment-tree',
  name: 'Persistent Segment Tree',
  category: 'Data Structures',
  complexity: {
    time: 'O(log N) per operation',
    space: 'O(N log N)'
  },
  description: 'A segment tree that preserves previous versions of the data structure. Each update creates a new version while reusing unchanged nodes, enabling queries on historical states with O(log N) time per operation.'
};
